import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { authStorage, authLog } from '@practium/features/auth';
import { User } from '@practium/shared';
import { toApiError, getApiErrorMessage, getApiUrl } from '../utils';

interface GoogleAuthApiResponse {
	csrfToken: string;
	accessToken: string;
}

interface ConsentAcceptItem {
	policyVersionId: string;
	accepted: boolean;
}

interface GoogleRegisterParams {
	code: string;
	consents: ConsentAcceptItem[];
}

export const useGoogleRegister = () => {
	return useMutation({
		mutationFn: async ({ code, consents }: GoogleRegisterParams) => {
			const apiUrl = getApiUrl();

			const { data } = await axios
				.post<GoogleAuthApiResponse>(
					`${apiUrl}auth/google/register`,
					{ code, redirectUri: 'postmessage', consents },
					{ withCredentials: true }
				)
				.catch((error) => {
					throw toApiError(error, 'Erro ao cadastrar com o Google');
				});

			const cleanToken = data.accessToken.replace(/^bearer\s+/i, '');

			if (data.csrfToken) {
				authStorage.saveCsrf(data.csrfToken);
			}

			const { data: user } = await axios
				.get<User>(`${apiUrl}user/get`, {
					headers: { Authorization: `bearer ${cleanToken}` },
				})
				.catch((error) => {
					throw toApiError(error, 'Erro ao cadastrar com o Google');
				});

			return { user, token: cleanToken };
		},
		onSuccess: ({ user, token }) => {
			authStorage.saveSession(user, token, true);
			authLog.logRegistration(user._id, user.email);
		},
		onError: (error) => {
			console.error(
				'Erro ao cadastrar com Google:',
				getApiErrorMessage(error, 'Erro ao cadastrar com o Google')
			);
		},
	});
};
